import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router'

import { useRecoilValue } from 'recoil'

import { PageHeader, Button } from 'mailup-web-components'

import { notifyParent } from 'Helpers/notifyParent'

import { resultsStateEmptyState } from '../recoil/state/results'
import useRedirectorUrl from 'Hooks/useRedirectorUrl'

const Header = () => {
  const intl = useIntl()
  const history = useHistory()
  const [redirectUrl] = useRedirectorUrl()

  const isEmptyState = useRecoilValue(resultsStateEmptyState)

  useEffect(() => {
    notifyParent('selectMenuItemReact', ['EmailMessages', redirectUrl])
  }, [redirectUrl])

  const breadcrumbsItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Messages' }),
      'data-mu-test': 'breadcrumb-item__messages',
      className: 'test-breadcrumb-item__messages'
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Email' }),
      'data-mu-test': 'breadcrumb-item__email',
      className: 'test-breadcrumb-item__email'
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Saved' }),
      'data-mu-test': 'breadcrumb-item__saved',
      className: 'test-breadcrumb-item__saved'
    }
  ]

  const ControlsComponent = () =>
    isEmptyState ? null : (
      <Button
        kind='primary'
        size='lg'
        onClick={() => history.push('/messages/email/new')}
        className='test-newEmail'
        data-mu-test='new-email'
      >
        {intl.formatMessage({ id: 'Load.EmailMessageList.NewEmailButton' })}
      </Button>
    )

  return (
    <PageHeader
      breadcrumbsItems={breadcrumbsItems}
      ControlsComponent={ControlsComponent}
      title={intl.formatMessage({ id: 'Load.NavMenu.Saved' })}
    />
  )
}

export default Header
